// extracted by mini-css-extract-plugin
module.exports = {"description":"nZqN0FRW","small":"__8P12ygyD","title":"oo6oNpQR","subtitle":"_1qa6fRw"};